module.exports = __webpack_public_path__ + "static/UAmobSlide5-9392d0092718de81149ae9dd0c283be5.jpg";